'use strict';

var Css = require("bs-css-emotion/lib/js/src/Css.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Theme$PvpcontrollerWeb = require("../Theme.js");
var Changelog$PvpcontrollerWeb = require("./Changelog.js");
var ChangeModel$PvpcontrollerWeb = require("../models/ChangeModel.js");
var ChangeLogEntry$PvpcontrollerWeb = require("./ChangeLogEntry.js");
var ChangelogService$PvpcontrollerWeb = require("../services/ChangelogService.js");

var groupLabel = Curry._1(Css.style, {
      hd: Css.height(Css.px(80)),
      tl: /* [] */0
    });

var groupLabelText = Curry._1(Css.style, {
      hd: Css.paddingTop(Css.px(25)),
      tl: /* [] */0
    });

function changeDateTimestamp(change) {
  return new Date(change.timestamp).setHours(23.0, 0.0, 0.0, 0.0);
}

function getChangesGrouped(changes) {
  var groupedChanges = [];
  var lastChangeDateTimestamp = {
    contents: undefined
  };
  Belt_Array.forEach(changes, (function (change) {
          var timestamp = changeDateTimestamp(change);
          var lastTimestamp = lastChangeDateTimestamp.contents;
          if (lastTimestamp !== undefined) {
            if (timestamp !== lastTimestamp) {
              groupedChanges.push([change]);
              lastChangeDateTimestamp.contents = timestamp;
            } else {
              Belt_Array.getExn(groupedChanges, groupedChanges.length - 1 | 0).push(change);
            }
          } else {
            groupedChanges.push([change]);
            lastChangeDateTimestamp.contents = timestamp;
          }
          
        }));
  return groupedChanges;
}

function getGroupsTimestampLabel(changes) {
  var firstChange = Belt_Array.getExn(changes, 0);
  return ChangeModel$PvpcontrollerWeb.Timestamp.toString(firstChange.timestamp, true, undefined);
}

function renderTable(changes, simplified) {
  if (changes.length > 0) {
    return React.createElement("table", undefined, React.createElement("tbody", undefined, Belt_Array.mapWithIndex(getChangesGrouped(changes), (function (i, changes) {
                          return React.createElement(React.Fragment, {
                                      children: null,
                                      key: String(i)
                                    }, React.createElement("tr", {
                                          className: Theme$PvpcontrollerWeb.title + " " + groupLabel
                                        }, React.createElement("td", {
                                              className: groupLabelText,
                                              colSpan: 4
                                            }, getGroupsTimestampLabel(changes))), Belt_Array.mapWithIndex(changes, (function (j, change) {
                                            var alt = j % 2 === 0;
                                            return React.createElement(ChangeLogEntry$PvpcontrollerWeb.make, ChangeLogEntry$PvpcontrollerWeb.makeProps(alt, change, simplified, undefined, String(i) + ":" + String(j), undefined));
                                          })));
                        }))));
  } else {
    return React.createElement("h3", {
                className: Theme$PvpcontrollerWeb.h3
              }, "Nothing to show");
  }
}

function ChangelogPage(Props) {
  var match = React.useState(function () {
        return /* Loading */0;
      });
  return React.createElement("div", undefined, React.createElement(Changelog$PvpcontrollerWeb.make, Changelog$PvpcontrollerWeb.makeProps(ChangelogService$PvpcontrollerWeb.getChangelog, undefined, match[0], match[1], 20, renderTable, 80, undefined, undefined)));
}

function makeProps(prim0, prim1) {
  var tmp = {};
  if (prim0 !== undefined) {
    tmp.key = prim0;
  }
  return tmp;
}

var make = ChangelogPage;

exports.makeProps = makeProps;
exports.make = make;
/* groupLabel Not a pure module */
